import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-md-6" }
const _hoisted_2 = { class: "text-block" }
const _hoisted_3 = {
  class: "xyz-in",
  xyz: "fade down-2 duration-8 delay-1"
}
const _hoisted_4 = {
  class: "lead mt-2 xyz-in",
  xyz: "fade down duration-8 delay-3"
}
const _hoisted_5 = {
  class: "lead mt-2 xyz-in",
  xyz: "fade duration-8 delay-3"
}

import { strings } from '@/strings'
import { locator, ParsedPhoneNumber } from '@/utils/locator'
import { router } from '@/router'
import PhoneInput from '@/components/ui/phone-input.vue'



export default /*@__PURE__*/_defineComponent({
  __name: 'hero-content',
  setup(__props) {

const submit = (parsed_number: ParsedPhoneNumber) => {
  // init locator and save parsed number
  locator.init(parsed_number)
  router.push(`/sign-up?d=${encodeURIComponent(parsed_number.dial)}&n=${parsed_number.number}`)
}

// get url arguments
const args = new URLSearchParams(window.location.search)

// get gclid and save if defined
let h1 = args.get('h')
if (!h1) {
  h1 = strings.core["Slogan"]
}
console.log(h1)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(h1)), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(strings).core['PhoneError']), 1)
    ]),
    _createVNode(PhoneInput, {
      onReady: submit,
      ref: "phone-input",
      btn_text: _unref(strings).core['Locate'],
      class: "mt-3 xyz-in",
      xyz: "fade duration-8 delay-3"
    }, null, 8, ["btn_text"]),
    _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(strings).core['Description']), 1)
  ]))
}
}

})